import { render, staticRenderFns } from "./SurveyType.vue?vue&type=template&id=a18429d8&scoped=true"
import script from "./SurveyType.vue?vue&type=script&lang=ts"
export * from "./SurveyType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18429d8",
  null
  
)

export default component.exports